import React, { useRef, useEffect } from "react";

// storage.milu.com 不允许跨域 fetch，无法自动解析时长，固定使用该值
// 将此常量调整为与 GIF 实际播放时长一致可获得最佳效果
const GIF_DURATION = 3000;

// gif 高度 20，静态图高度 25
const getDefaultSize = (src) => ({
  height: src && src.toLowerCase().endsWith(".gif") ? 20 : 26,
  verticalAlign: "middle",
});

// 双图交替：重置时操作的始终是隐藏那张，用户不会看到任何闪烁
export default function HonorIconGif({ src, className, style }) {
  const aRef      = useRef(null);
  const bRef      = useRef(null);
  const activeRef = useRef("a");

  useEffect(() => {
    if (!src) return;
    const doSwap = (current, next, label) => {
      current.style.opacity  = "0";
      current.style.position = "absolute";
      next.style.opacity     = "1";
      next.style.position    = "relative";
      activeRef.current      = label;
    };

    const swap = () => {
      const showingA = activeRef.current === "a";
      const current  = showingA ? aRef.current : bRef.current;
      const next     = showingA ? bRef.current : aRef.current;
      const label    = showingA ? "b" : "a";
      if (!current || !next) return;

      next.src = "";
      next.src = src;
      next.decode()
        .then(() => doSwap(current, next, label))
        .catch(() => doSwap(current, next, label));
    };

    const timer = setInterval(swap, GIF_DURATION);
    return () => clearInterval(timer);
  }, [src]);

  if (!src) return null;

  const imgStyle = { ...getDefaultSize(src), ...style };

  return (
    <span style={{ position: "relative", display: "inline-block", ...style }}>
      <img ref={aRef} src={src} alt="" className={className}
        style={{ ...imgStyle, opacity: 1, position: "relative", top: -2 }} />
      <img ref={bRef} src={src} alt="" className={className}
        style={{ ...imgStyle, opacity: 0, position: "absolute", top: -2, left: 0 }} />
    </span>
  );
}
